import { FunctionComponent, PropsWithChildren, useEffect } from "react";
import { createPortal } from "react-dom";
import styled, { CSSProperties } from "styled-components";

type OwnProps = {
  onClose: () => any;
  style?: CSSProperties;
  className?: string;
};
type Props = PropsWithChildren<OwnProps>;

const ModalRoot = styled.div`
  position: fixed;
  height: 100%;
  width: 100%;
  background: #00000080;
  z-index: 10;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ModalContent = styled.div`
  background: #14202f;
  padding: 32px;
  border-radius: 5px;
  max-height: 90vh;
  overflow: auto;
`;

const Modal: FunctionComponent<Props> = ({ onClose, children, style, className }) => {
  return createPortal(
    <ModalRoot onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()} style={style} className={className}>
        {children}
      </ModalContent>
    </ModalRoot>,
    document.body
  );
};

export default Modal;
